import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AdultosOnboardingStepper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_card_id-adultos-mobile${currentParams}`);
  };

  return (
      <div className="adultos-stepper">
        <div className="overlap-wrapper">
          <div className="overlap">
            <div className="overlap-group-3">
              <div className="frame-5">
                <img
                    className="image"
                    alt="Image"
                    src="/img/folder-young-adultos.png"
                />

                <div className="subtitle">Welcome!</div>

                <p className="subtitle-2">Let’s open your online account</p>

                <div className="frame-6">
                  <div className="frame-7">
                    <div className="ellipse-3" />

                    <div className="ellipse-3" />

                    <div className="ellipse-3" />

                    <div className="ellipse-3" />

                    <div className="ellipse-3" />

                    <div className="ellipse-3" />
                  </div>

                  <div className="frame-8">
                    <div className="subtitle-wrapper">
                      <div className="subtitle-3">
                        Accept Terms and Conditions
                      </div>
                    </div>

                    <div className="group-2">
                      <div className="subtitle-4">Register your Email</div>
                    </div>

                    <div className="group-3">
                      <div className="subtitle-4">Scan your ID card</div>
                    </div>

                    <div className="group-4">
                      <div className="subtitle-4"> Validate your identity</div>
                    </div>

                    <div className="subtitle-wrapper">
                      <div className="subtitle-3">
                        Register your Mobile number
                      </div>
                    </div>

                    <div className="group-5">
                      <div className="subtitle-4">Generate your credentials</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="frame-wrapper">
                <div className="frame-9 highlighted-button">
                  <div className="text-wrapper-7" onClick={handleButtonClick}>
                    Open account
                  </div>
                </div>
              </div>
            </div>

            <div className="frame-10">
              <div className="status-bar">
                {/* <div className="bars-status-default">
                <div className="action">
                  <div className="text-wrapper-8">9:50</div>
                </div>

                <img
                  className="container"
                  alt="Container"
                  src="/img/container.png"
                />
              </div> */}
              </div>

              <div className="panel-panel-primary">
                <div className="title">Terms and Conditions</div>

                <img
                    className="icons-arrow-back"
                    alt="Icons arrow back"
                    src="/img/icons-arrow-back-1.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
